module.exports = __webpack_public_path__ + "images/logo-2x.afd5e6d53d1408c719f0aa479ff0a9ce.png";